import React, { useState } from 'react';
import { IAccordionProps } from '../../../interfaces/interfaces';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';

function Accordion(props: IAccordionProps): JSX.Element {
  const { title, contentCount, children, className, openerClassName } = props;
  const [isOpened, setOpened] = useState(false);

  const toggle = () => {
    setOpened(!isOpened);
  };
  const accordionTitle = `${title}`;
  return (
    <>
      <div className={`accordion ${className || ''} ${isOpened ? 'opened' : 'closed'}`}>
        <a
          role="button"
          className={`link accordion-opener ${openerClassName || ''}`}
          onClick={toggle}
          onKeyDown={(e) => {
            keyboardTriggerBasic(e, toggle);
          }}
          tabIndex={0}
        >
          <span className="ic-plus" />
          {/* eslint-disable-next-line react/no-danger */}
          <p
            className="tx_1 font-color-blue no-margin-bottom"
            dangerouslySetInnerHTML={{ __html: accordionTitle }}
          />{' '}
          {contentCount > 0 && <span className="count-badge">{contentCount}</span>}
        </a>

        {isOpened && children}
      </div>
    </>
  );
}
export default Accordion;
